import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'underscore';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from 'app/shared/sharedData';

@Component({
    selector: 'create-mobile-application',
    templateUrl: './createMobileApplication.html'
})
export class CreateMobileComponent{
    public _baseUrl: any;
    public mobileApps: any = [];
    public isUpdate: any = false;
    public mobileAppData: any;
    constructor(
        public router: Router,
        public _per: PermissionHelper,
        public _global: Configuration,
        public http: HttpClientCustom,
        public translate: TranslateService,
        public _toaster: ToasterComponent, 
        vcr: ViewContainerRef,
        public _location: Location,
        public activeModal: NgbActiveModal,
        public share: SharedData
    ) {
        let self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
        let shareData = self.share.getData();
        if (shareData.hasOwnProperty('mobileApp')) {
            let mobileAppData = shareData['mobileApp'];
            if (_.has(mobileAppData,'mobileAppName')) {
                self.mobileAppData = mobileAppData;
                self.isUpdate = true;
            }else{
                self.mobileAppData  = {
                    mobileAppName: '',
                    versionAndroid:  '',
                    versionIos: '',
                    fireBaseKey: '',
                    mobileAppKey: '',
                    redirectUrlAndroid: '',
                    redirectUrlIos: '',
                    isDefault: false
                }
                self.isUpdate = false;
            }
        } else {
            self.mobileAppData  = {
                mobileAppName: '',
                versionAndroid:  '',
                versionIos: '',
                fireBaseKey: '',
                mobileAppKey: '',
                redirectUrlAndroid: '',
                redirectUrlIos: '',
                isDefault: false
            }
            self.isUpdate = false;
        }
    }

    public checkForValidData() {
        let self = this;
        if (_.isEmpty(self.mobileAppData.mobileAppName) || _.isNull(self.mobileAppData.mobileAppName) || _.isUndefined(self.mobileAppData.mobileAppName)){
            return false;
        } else if (_.isEmpty(self.mobileAppData.mobileAppKey) || _.isNull(self.mobileAppData.mobileAppKey) || _.isUndefined(self.mobileAppData.mobileAppKey)){
            return false;
        } else {
            return true;
        }
    }

    public save() {
        let self = this;
        let isValid = self.checkForValidData();
        if (isValid && !self.isUpdate){
            let url =  self._baseUrl + 'v1/superAdmin/mobAppManagement/createMobileApp';
            self.http.post(url, self.mobileAppData).subscribe((result:any) => {
                if(!result.errorMessage){
                    self.translate.get('mobileAppCreated').subscribe((msg) => {
                        self._toaster.showSuccess(msg);
                        self.activeModal.close();
                    });
                }else{
                    self.translate.get('mobileAppAlreadyCreated').subscribe((msg) => {
                        self._toaster.showError(msg);
                        self.activeModal.close();
                    });
                }
            }, (error: any) => {
                self.translate.get('mandNotEmpty').subscribe((msg)=>{
                    self._toaster.showError(msg);
                });
            });
        }else if (isValid && self.isUpdate){
            let url =  self._baseUrl + 'v1/superAdmin/mobAppManagement/updateMobileApp';
            self.http.post(url, self.mobileAppData).subscribe((result) => {
                self.translate.get('mobileAppUpdated').subscribe((msg) => {
                    self._toaster.showSuccess(msg);
                    self.activeModal.close();
                });
            }, (error: any) => {
                self.translate.get('mandNotEmpty').subscribe((msg)=>{
                    self._toaster.showError(msg);
                });
            });
        }else {
            self.translate.get('mandNotEmpty').subscribe((msg)=>{
                self._toaster.showError(msg);
            });
        }
    }

    public cancel(){
        let self = this;
        self.activeModal.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/superAdmin/createMobileApplication.ts